// @ts-nocheck
import { BlockOrderCore } from './BlockOrderCore'
import { IBlockCoreConfig, IBlockConfig, BlockFieldPosition } from './typing'

export class BlockCore<
  B extends string = string,
  Code extends number | string = number | string
> extends BlockOrderCore<B> {
  config: IBlockCoreConfig<B, Code>
  codes: Array<Code> = []
  positions: Partial<Record<Code, BlockFieldPosition<B, Code>>> = {}

  constructor(config: IBlockCoreConfig<B, Code>, order: B[]) {
    super(order)

    this.config = config

    Object.entries(config).forEach(([blockType, blockConfig]: [B, IBlockConfig<Code>]) => {
      for (let index = 0; index < blockConfig?.fields?.length; index++) {
        const fieldConfig = blockConfig?.fields?.[index]
        const code = fieldConfig?.code
        this.codes.push(code)
        this.positions[code] = { blockType, index, fieldConfig, blockConfig }
      }
    })
  }

  getBlockConfig(blockType: B) {
    return this?.config?.[blockType] ?? null
  }

  /**
   * 根据 eleCode 获取对应 fieldConfig 以及位置信息
   * @param code
   * @returns
   */
  getPosition(code: Code) {
    return this.positions?.[code] ?? null
  }

  /**
   * 获取改 blockType 中包含的 eleCode
   * @param blockType
   * @returns
   */
  getBlockTypeCodes(blockType: B) {
    return this.getBlockConfig(blockType)?.fields?.map(config => config?.code) ?? []
  }
}
